import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {usePremiListModel} from "@/stores/models/premi-list-model";

export const usePremiListStore  = defineStore(
    'premiListStore',
    () => {
       
        const isLoading = ref(false);
        const selectedPegawai = ref(null);
        const dataSourcePremiList = ref(
            new DataSource({
                requireTotalCount: true,
                store: usePremiListModel().premiListCustomStore,
                filter: null,
            })
        );

        // const dataSourcePendidikanList = (additionalParams = null) => {
        //     // console.log('masuk dataSourcePendidikanList', additionalParams)
        //     return new DataSource({
        //       requireTotalCount: true,
        //       load: (loadOptions) => {
        //         // Handle load options and additionalParams separately
        //         return usePendidikanListModel().pendidikanListCustomStore.load([loadOptions, additionalParams]);
        //       }
        //     });
        // };

        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourcePremiList.value.reload();
        };

        const initialized = ()=>{     
            dataSourcePremiList.value.reload();
        };

        return {
            dataSourcePremiList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state,
            selectedPegawai

        }
    }
);